import DevExpress from 'devextreme';
import { DataType, HorizontalAlignment, HorizontalEdge, SortOrder, ValidationRule } from 'devextreme/common';
import { DeepPartial } from 'devextreme/core';
import { DxElement, ElementWrapper } from 'devextreme/core/element';
import { template } from 'devextreme/core/templates/template';
import { Format } from 'devextreme/localization';
import {
  Column,
  ColumnBase,
  ColumnButton,
  ColumnCellTemplateData,
  ColumnCustomizeTextArg,
  ColumnEditCellTemplateData,
  ColumnGroupCellTemplateData,
  ColumnHeaderCellTemplateData,
  ColumnHeaderFilter,
  ColumnLookup,
  DataGridCommandColumnType,
  DataGridPredefinedColumnButton,
  dxDataGridColumn,
  FilterOperation,
  FilterType,
  SelectedFilterOperation,
} from 'devextreme/ui/data_grid';
import { SimpleItem } from 'devextreme/ui/form';
import { CompareHelper } from 'libs/abc/core';
import { AbcDropDownBoxComponent } from 'libs/abc/ui-components/src/lib/core/src/abc-drop-down-box/abc-drop-down-box.component';
import { AbcCoreComponent } from 'libs/abc/ui-components/src/lib/core/src/abcCoreComponent';
import { AbcCoreContainerService } from 'libs/abc/ui-components/src/lib/core/src/abcCoreContainer.service';

// export class _AbcGridColumn<TRowData = any, TKey = any> implements DevExpress.ui.dxDataGrid.Column {
//   allowExporting?: boolean;
//   allowGrouping?: boolean;
//   autoExpandGroup?: boolean;
//   buttons?: (
//     | DevExpress.ui.dxDataGrid.DataGridPredefinedColumnButton
//     | DevExpress.ui.dxDataGrid.ColumnButton<TRowData, TKey>
//   )[];
//   calculateGroupValue?: string | ((this: DevExpress.ui.dxDataGrid.ColumnBase, rowData: any) => any);
//   cellTemplate?:
//     | DevExpress.core.template
//     | ((
//         cellElement: DevExpress.core.DxElement,
//         cellInfo: DevExpress.ui.dxDataGrid.ColumnCellTemplateData<any, any>
//       ) => any);
//   editCellTemplate?:
//     | DevExpress.core.template
//     | ((
//         cellElement: DevExpress.core.DxElement,
//         cellInfo: DevExpress.ui.dxDataGrid.ColumnEditCellTemplateData<any, any>
//       ) => any);
//   groupCellTemplate?:
//     | DevExpress.core.template
//     | ((
//         cellElement: DevExpress.core.DxElement,
//         cellInfo: DevExpress.ui.dxDataGrid.ColumnGroupCellTemplateData<any, any>
//       ) => any);
//   groupIndex?: number;
//   headerCellTemplate?:
//     | DevExpress.core.template
//     | ((
//         columnHeader: DevExpress.core.DxElement,
//         headerInfo: DevExpress.ui.dxDataGrid.ColumnHeaderCellTemplateData<any, any>
//       ) => any);
//   showWhenGrouped?: boolean;
//   type?: DevExpress.ui.dxDataGrid.DataGridCommandColumnType;
//   alignment?: DevExpress.common.HorizontalAlignment;
//   allowEditing?: boolean;
//   allowFiltering?: boolean;
//   allowFixing?: boolean;
//   allowHeaderFiltering?: boolean;
//   allowHiding?: boolean;
//   allowReordering?: boolean;
//   allowResizing?: boolean;
//   allowSearch?: boolean;
//   allowSorting?: boolean;
//   calculateCellValue?: (this: DevExpress.common.grids.ColumnBase, rowData: any) => any;
//   defaultCalculateCellValue?: this['calculateCellValue'];
//   calculateDisplayValue?: string | ((this: DevExpress.common.grids.ColumnBase, rowData: any) => any);
//   calculateFilterExpression?: (
//     this: DevExpress.common.grids.ColumnBase,
//     filterValue: any,
//     selectedFilterOperation: string | null,
//     target: string
//   ) => string | Array<any> | Function;
//   defaultCalculateFilterExpression?: this['calculateFilterExpression'];
//   calculateSortValue?: string | ((this: DevExpress.common.grids.ColumnBase, rowData: any) => any);
//   caption?: string;
//   cssClass?: string;
//   customizeText?: (
//     this: DevExpress.common.grids.ColumnBase,
//     cellInfo: DevExpress.common.grids.ColumnCustomizeTextArg
//   ) => string;
//   dataField?: string;
//   dataType?: DevExpress.common.DataType;
//   editorOptions?: any;
//   encodeHtml?: boolean;
//   falseText?: string;
//   filterOperations?: string[];
//   filterType?: DevExpress.common.grids.FilterType;
//   filterValues?: any[];
//   fixed?: boolean;
//   fixedPosition?: DevExpress.common.HorizontalEdge;
//   formItem?: DevExpress.ui.dxFormSimpleItem;
//   format?: DevExpress.ui.Format;
//   headerFilter?: DevExpress.ui.dxDataGrid.ColumnHeaderFilter;
//   hidingPriority?: number;
//   isBand?: boolean;
//   lookup?: DevExpress.common.grids.ColumnLookup;
//   minWidth?: number;
//   name?: string;
//   ownerBand?: number;
//   selectedFilterOperation?: DevExpress.common.grids.SelectedFilterOperation;
//   setCellValue?: (
//     this: DevExpress.common.grids.ColumnBase,
//     newData: any,
//     value: any,
//     currentRowData: any
//   ) => void | PromiseLike<void>;
//   defaultSetCellValue?: this['setCellValue'];
//   showEditorAlways?: boolean;
//   showInColumnChooser?: boolean;
//   sortIndex?: number;
//   sortOrder?: DevExpress.common.SortOrder;
//   sortingMethod?: (this: DevExpress.common.grids.ColumnBase, value1: any, value2: any) => number;
//   trueText?: string;
//   validationRules?: DevExpress.common.ValidationRule[];
//   visibleIndex?: number;
//   filterValue?: any;

//   renderAsync?: boolean;
//   visible?: boolean;

//   width?: number | string;

//   constructor() {}

//   public setCustomCellEditor?(
//     abcCoreContainerService: AbcCoreContainerService,
//     dropDownBoxSetter: (dropDownBox: AbcDropDownBoxComponent, options: any) => Promise<void>
//   ) {
//     this.editCellTemplate = async (container, options) => {
//       const dropdownBox: AbcCoreComponent = abcCoreContainerService.createComponent(null, AbcDropDownBoxComponent);
//       await dropDownBoxSetter(<AbcDropDownBoxComponent>dropdownBox.componentRef.instance, options);
//       container.append(dropdownBox.domElement);
//     };
//   }

//   public setDisplayTextDataField?(dataField: string): void {
//     this.calculateDisplayValue = dataField;
//     this.calculateSortValue = dataField;
//     this.calculateGroupValue = dataField;
//     this.calculateFilterExpression = (filterValue: any, selectFilterOperation: string, target: string) => {
//       return [dataField, selectFilterOperation, filterValue];
//     };
//     let f = this.headerFilter;
//     if (!f) {
//       f = {};
//       this.headerFilter = f;
//     }
//     let lastDataSource: any;
//     let lastFilter: Object;
//     let dataItems: any[];
//     f.dataSource = (options) => {
//       const ds = options.component?.getDataSource();
//       const filter = options.component?.getCombinedFilter();
//       const arr = ds?.items();
//       if (arr) {
//         options.dataSource.postProcess = (items) => {
//           if (dataItems && lastDataSource === ds && CompareHelper.areDeepEqual(filter, lastFilter)) {
//             return dataItems;
//           }
//           dataItems = [];
//           lastDataSource = ds;
//           lastFilter = filter;
//           for (const orig of items) {
//             const item = arr.find((item) => item[this.dataField] == orig.value);
//             if (item) {
//               dataItems.push({ value: item[dataField], text: item[dataField] });
//             }
//           }
//           return dataItems;
//         };
//       }
//     };
//   }
// }

export class _AbcGridColumn<TRowData = any, TKey = any> implements Column {
  /**
   * Specifies whether data from this column should be exported. Applies only if the column is visible.
   */
  allowExporting?: boolean;
  /**
   * Specifies whether the user can group data by values of this column. Applies only when grouping is enabled.
   */
  allowGrouping?: boolean;
  /**
   * Specifies whether groups appear expanded or not when records are grouped by a specific column. Setting this property makes sense only when grouping is allowed for this column.
   */
  autoExpandGroup?: boolean;
  /**
   * Allows you to customize buttons in the edit column or create a custom command column. Applies only if the column&apos;s type is &apos;buttons&apos;.
   */
  buttons?: Array<DataGridPredefinedColumnButton | ColumnButton<TRowData, TKey>>;
  /**
   * Sets custom column values used to group grid records.
   */
  calculateGroupValue?: string | ((this: ColumnBase, rowData: TRowData) => any);
  /**
   * Specifies a custom template for data cells.
   */
  cellTemplate?: template | ((cellElement: DxElement, cellInfo: ColumnCellTemplateData<TRowData, TKey>) => any);
  /**
   * An array of grid columns.
   */
  columns?: Array<Column<TRowData, TKey> | string>;
  /**
   * Specifies a custom template for data cells in an editing state.
   */
  editCellTemplate?: template | ((cellElement: DxElement, cellInfo: ColumnEditCellTemplateData<TRowData, TKey>) => any);
  /**
   * Specifies a custom template for group cells (group rows).
   */
  groupCellTemplate?:
    | template
    | ((cellElement: DxElement, cellInfo: ColumnGroupCellTemplateData<TRowData, TKey>) => any);
  /**
   * Specifies the index of a column when grid records are grouped by the values of this column.
   */
  groupIndex?: number;
  /**
   * Specifies a custom template for column headers.
   */
  headerCellTemplate?:
    | template
    | ((columnHeader: DxElement, headerInfo: ColumnHeaderCellTemplateData<TRowData, TKey>) => any);
  /**
   * Specifies whether or not to display the column when grid records are grouped by it.
   */
  showWhenGrouped?: boolean;
  /**
   * Specifies the command column that this object customizes.
   */
  type?: DataGridCommandColumnType;
  /**
   * Aligns the content of the column.
   */
  alignment?: HorizontalAlignment;
  /**
   * Specifies whether a user can edit values in the column at runtime. By default, inherits the value of the editing.allowUpdating property.
   */
  allowEditing?: boolean;
  /**
   * Specifies whether data can be filtered by this column. Applies only if filterRow.visible is true.
   */
  allowFiltering?: boolean;
  /**
   * Specifies whether a user can fix the column at runtime. Applies only if columnFixing.enabled is true.
   */
  allowFixing?: boolean;
  /**
   * Specifies whether the header filter can be used to filter data by this column. Applies only if headerFilter.visible is true. By default, inherits the value of the allowFiltering property.
   */
  allowHeaderFiltering?: boolean;
  /**
   * Specifies whether a user can hide the column using the column chooser at runtime. Applies only if columnChooser.enabled is true.
   */
  allowHiding?: boolean;
  /**
   * Specifies whether users can reorder this column. Overrides the allowColumnReordering property value.
   */
  allowReordering?: boolean;
  /**
   * Specifies whether a user can resize the column at runtime. Applies only if allowColumnResizing is true.
   */
  allowResizing?: boolean;
  /**
   * Specifies whether this column can be searched. Applies only if searchPanel.visible is true. Inherits the value of the allowFiltering property by default.
   */
  allowSearch?: boolean;
  /**
   * Specifies whether a user can sort rows by this column at runtime. Applies only if sorting.mode differs from &apos;none&apos;.
   */
  allowSorting?: boolean;
  /**
   * Calculates custom cell values. Use this function to create an unbound data column.
   */
  calculateCellValue?: (this: ColumnBase, rowData: TRowData) => any;
  defaultCalculateCellValue?: this['calculateCellValue'];
  /**
   * Calculates custom display values for column cells. Requires specifying the dataField or calculateCellValue property. Used in lookup optimization.
   */
  calculateDisplayValue?: string | ((this: ColumnBase, rowData: TRowData) => any);
  /**
   * Specifies the column&apos;s custom rules to filter data.
   */
  calculateFilterExpression?: (
    this: ColumnBase,
    filterValue: any,
    selectedFilterOperation: string | null,
    target: string
  ) => string | Array<any> | Function;
  defaultCalculateFilterExpression?: this['calculateFilterExpression'];
  /**
   * Calculates custom values used to sort this column.
   */
  calculateSortValue?: string | ((this: ColumnBase, rowData: TRowData) => any);
  /**
   * Specifies a caption for the column.
   */
  caption?: string;
  /**
   * Specifies a CSS class to be applied to the column.
   */
  cssClass?: string;
  /**
   * Customizes the text displayed in column cells.
   */
  customizeText?: (this: ColumnBase, cellInfo: ColumnCustomizeTextArg) => string;
  /**
   * Binds the column to a field of the dataSource.
   */
  dataField?: string;
  /**
   * Casts column values to a specific data type.
   */
  dataType?: DataType;
  /**
   * Configures the default UI component used for editing and filtering in the filter row.
   */
  editorOptions?: any;
  /**
   * Specifies whether HTML tags are displayed as plain text or applied to the values of the column.
   */
  encodeHtml?: boolean;
  /**
   * In a boolean column, replaces all false items with a specified text. Applies only if showEditorAlways property is false.
   */
  falseText?: string;
  /**
   * Specifies available filter operations. Applies if allowFiltering is true and the filterRow and/or filterPanel are visible.
   */
  filterOperations?: Array<FilterOperation | string>;
  /**
   * Specifies whether a user changes the current filter by including (selecting) or excluding (clearing the selection of) values. Applies only if headerFilter.visible and allowHeaderFiltering are true.
   */
  filterType?: FilterType;
  /**
   * Specifies the value to display in the filter row.
   */
  filterValue?: any;
  /**
   * Sets the values in the header filter.
   */
  filterValues?: Array<any>;
  /**
   * Fixes the column.
   */
  fixed?: boolean;
  /**
   * Specifies the UI component&apos;s edge to which the column is fixed. Applies only if columns[].fixed is true.
   */
  fixedPosition?: HorizontalEdge;
  /**
   * Configures the form item that the column produces in the editing state. Applies only if editing.mode is &apos;form&apos; or &apos;popup&apos;.
   */
  formItem?: SimpleItem;
  /**
   * Formats a value before it is displayed in a column cell.
   */
  format?: Format;
  /**
   * Specifies data settings for the header filter.
   */
  headerFilter?: ColumnHeaderFilter;
  /**
   * Specifies the order in which columns are hidden when the UI component adapts to the screen or container size. Ignored if allowColumnResizing is `true` and columnResizingMode is &apos;widget&apos;.
   */
  hidingPriority?: number;
  /**
   * Specifies whether the column organizes other columns into bands.
   */
  isBand?: boolean;
  /**
   * Specifies properties of a lookup column.
   */
  lookup?: ColumnLookup;
  /**
   * Specifies the minimum width of the column.
   */
  minWidth?: number;
  /**
   * Specifies the column&apos;s unique identifier. If not set in code, this value is inherited from the dataField.
   */
  name?: string;
  /**
   * Specifies the band column that owns the current column. Accepts the index of the band column in the columns array.
   */
  ownerBand?: number;
  /**
   * Specifies whether to render the column after other columns and elements. Use if column cells have a complex template. Requires the width property specified.
   */
  renderAsync?: boolean;
  /**
   * Specifies a filter operation that applies when users use the filter row to filter the column.
   */
  selectedFilterOperation?: SelectedFilterOperation;
  /**
   * Specifies a function to be invoked after the user has edited a cell value, but before it is saved in the data source.
   */
  setCellValue?: (
    this: ColumnBase,
    newData: DeepPartial<TRowData>,
    value: any,
    currentRowData: TRowData
  ) => void | PromiseLike<void>;
  defaultSetCellValue?: this['setCellValue'];
  /**
   * Specifies whether the column displays its values in editors.
   */
  showEditorAlways?: boolean;
  /**
   * Specifies whether the column chooser can contain the column header.
   */
  showInColumnChooser?: boolean;
  /**
   * Specifies the index according to which columns participate in sorting.
   */
  sortIndex?: number;
  /**
   * Specifies the sort order of column values.
   */
  sortOrder?: SortOrder;
  /**
   * Specifies a custom comparison function for sorting. Applies only when sorting is performed on the client.
   */
  sortingMethod?: (this: ColumnBase, value1: any, value2: any) => number;
  /**
   * In a boolean column, replaces all true items with a specified text. Applies only if showEditorAlways property is false.
   */
  trueText?: string;
  /**
   * Specifies validation rules to be checked when cell values are updated.
   */
  validationRules?: Array<ValidationRule>;
  /**
   * Specifies whether the column is visible, that is, occupies space in the table.
   */
  visible?: boolean;
  /**
   * Specifies the position of the column regarding other columns in the resulting UI component.
   */
  visibleIndex?: number;
  /**
   * Specifies the column&apos;s width in pixels or as a percentage. Ignored if it is less than minWidth.
   */
  width?: number | string;
  constructor() {}

  public setCustomCellEditor?(
    abcCoreContainerService: AbcCoreContainerService,
    dropDownBoxSetter: (dropDownBox: AbcDropDownBoxComponent, options: any) => Promise<void>
  ) {
    this.editCellTemplate = async (container, options) => {
      const dropdownBox: AbcCoreComponent = abcCoreContainerService.createComponent(null, AbcDropDownBoxComponent);
      await dropDownBoxSetter(<AbcDropDownBoxComponent>dropdownBox.componentRef.instance, options);
      container.append(dropdownBox.domElement);
    };
  }

  public setDisplayTextDataField?(dataField: string): void {
    this.calculateDisplayValue = dataField;
    this.calculateSortValue = dataField;
    this.calculateGroupValue = dataField;
    this.calculateFilterExpression = (filterValue: any, selectFilterOperation: string, target: string) => {
      return [dataField, selectFilterOperation, filterValue];
    };
    let f = this.headerFilter;
    if (!f) {
      f = {};
      this.headerFilter = f;
    }
    let lastDataSource: any;
    let lastFilter: Object;
    let dataItems: any[];
    f.dataSource = (options) => {
      const ds = options.component?.getDataSource();
      const filter = options.component?.getCombinedFilter();
      const arr = ds?.items();
      if (arr) {
        options.dataSource.postProcess = (items) => {
          if (dataItems && lastDataSource === ds && CompareHelper.areDeepEqual(filter, lastFilter)) {
            return dataItems;
          }
          dataItems = [];
          lastDataSource = ds;
          lastFilter = filter;
          for (const orig of items) {
            const item = arr.find((item) => item[this.dataField] == orig.value);
            if (item) {
              dataItems.push({ value: item[dataField], text: item[dataField] });
            }
          }
          return dataItems;
        };
      }
    };
  }
}
